// Studio-Quality Harmonic Bell Chime using Web Audio API

export function playHarmonicChime(): void {
  try {
    const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioContextClass) return;
    const ctx = new AudioContextClass();
    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }

    const now = ctx.currentTime;
    const masterGain = ctx.createGain();
    masterGain.gain.setValueAtTime(0.4, now);
    masterGain.connect(ctx.destination);

    const playBellNote = (freq: number, startTime: number, duration: number, volume: number) => {
      // Fundamental Tone (Sine)
      const osc1 = ctx.createOscillator();
      const gain1 = ctx.createGain();
      osc1.type = 'sine';
      osc1.frequency.setValueAtTime(freq, startTime);

      gain1.gain.setValueAtTime(0.001, startTime);
      gain1.gain.linearRampToValueAtTime(volume, startTime + 0.015);
      gain1.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);

      osc1.connect(gain1);
      gain1.connect(masterGain);
      osc1.start(startTime);
      osc1.stop(startTime + duration);

      // Harmonic Overtone (Triangle) - provides warm crystalline sparkle
      const osc2 = ctx.createOscillator();
      const gain2 = ctx.createGain();
      osc2.type = 'triangle';
      osc2.frequency.setValueAtTime(freq * 2, startTime);

      gain2.gain.setValueAtTime(0.001, startTime);
      gain2.gain.linearRampToValueAtTime(volume * 0.35, startTime + 0.012);
      gain2.gain.exponentialRampToValueAtTime(0.0001, startTime + duration * 0.7);

      osc2.connect(gain2);
      gain2.connect(masterGain);
      osc2.start(startTime);
      osc2.stop(startTime + duration);
    };

    // 3-Stage Cascading Harmonic Bell: D5 -> A5 -> E6
    playBellNote(587.33, now, 0.5, 0.45);        // Warm opening note
    playBellNote(880.00, now + 0.11, 0.8, 0.55); // Rich resolving bell note
    playBellNote(1318.51, now + 0.22, 0.6, 0.28);// Crystal shimmer overtone
  } catch {
    // AudioContext blocked or not supported
  }
}
